export enum RequestOtpResponseType {
  SUCCESS_OTP_SUBMITTED = "SUCCESS_OTP_SUBMITTED",
  ERROR_REFERENCE_NUMBER_INCORRECT = "ERROR_REFERENCE_NUMBER_INCORRECT",
  ERROR_APPLICATION_SUBMITTED = "ERROR_APPLICATION_SUBMITTED",
}

export type RequestOtpResponse = {
  type: RequestOtpResponseType;
}
